import { EarticleType } from '../utils/enum.util'
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { InvoiceModel } from './invoice.model';

export class ArticleModel {

    private _type: EarticleType = 2;
    private _price: number      = null;
    private _quantity: number   = 1;
    private _about: string      = '';
    private _bike: any;
    private _free: boolean      = false;
    private _errors: any        = true;
    private _invoice: any;


    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(parent: any) {
        this.invoice = parent;
    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    modelChange() {
        this.invoice.save();
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this.price, 'price', EvalidatorRequire.Require, [
                {fn: validator.double, options: {min: -100000, max: 100000}}
            ])
            .addField(this.quantity, 'quantity', EvalidatorRequire.Require, [
                {fn: validator.integer, options: {min: 1, max: 100000}}
            ]);
        if (this.type != EarticleType.Bike) {
            validator.addField(this.about, 'about', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 100}}
            ]);
        }
        this._errors = validator.run();

        return (this._errors == null);
    }


    //*************************************
    //*************** METHOD **************
    //*************************************
    getTypeText(): string {
        if (this.type == 0)
            return 'service';
        if (this.type == 1)
            return 'bike';
        return 'accessory'
    }

    doubleToString(value: number) {
        return value.toFixed(2);
    }

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get type(): EarticleType {
        return this._type;
    }

    set type(value: EarticleType) {
        this._type = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get quantity(): number {
        return this._quantity;
    }

    set quantity(value: number) {
        this._quantity = value;
    }

    get about(): string {
        return this._about;
    }

    set about(value: string) {
        this._about = value;
    }

    get bike(): any {
        return this._bike;
    }

    set bike(value: any) {
        this._bike = value;
    }

    get free(): boolean {
        return this._free;
    }

    set free(value: boolean) {
        this._free = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get invoice(): InvoiceModel {
        return this._invoice;
    }

    set invoice(value: InvoiceModel) {
        this._invoice = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/article.model.ts